import { Component, EventEmitter, Input, Output } from '@angular/core';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-signature-model',
  templateUrl: './signature-model.component.html',
  styleUrls: ['./signature-model.component.scss']
})
export class SignatureModelComponent {

  @Input() type = 'Add';
  @Input() selectedIndex: number | null = null;
  @Output() close = new EventEmitter<boolean>();
  @Output() updateSignatures = new EventEmitter<string[]>();

  public Editor = ClassicEditor as any;
  public editorConfig = {
    placeholder: 'Type your signature here...',
    toolbar: [
      'bold', 'italic', 'underline', '|',
      'link', '|',
      'undo', 'redo', '|',
      'imageUpload'
    ],
    image: {
      resizeOptions: [
        {
          name: 'resizeImage:original',
          label: 'Original',
          value: null
        },
        {
          name: 'resizeImage:50',
          label: '50%',
          value: '50'
        },
        {
          name: 'resizeImage:75',
          label: '75%',
          value: '75'
        }
      ],
      toolbar: ['imageStyle:inline', 'imageStyle:block', 'imageStyle:side', '|', 'resizeImage', '|', 'imageTextAlternative']
    }
  };

  btnLoading: boolean = false;
  signatures: string[] = [];
  newSignature: string = '';

  constructor(private toast: ToastrService) {}

  onReady(editor: any) {
    // Set custom upload adapter (optional, as you have)
  editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
    return new UploadAdapter(loader);
  };

  // Custom behavior: replace default Enter with Shift+Enter
  editor.editing.view.document.on(
    'enter',
    (evt: any, data: any) => {
      editor.execute('shiftEnter'); // insert <br> instead of <p>
      data.preventDefault();        // cancel default enter
      evt.stop();                   // stop further handling
    },
    { priority: 'high' }
  );
  }

  addSignature() {
    const trimmed = this.newSignature.trim();
    if (trimmed && this.signatures.length < 3) {
      this.signatures.push(trimmed);
      this.newSignature = ''; // reset input
    }
  }

  saveSignature() {
    if (this.signatures.length < 1) {
      this.toast.error('Please add at least one signature');
      return;
    }

    this.updateSignatures.emit(this.signatures);
    this.closeModal();
  }

  deleteSignature(index: number) {
    this.signatures.splice(index, 1);
  }

  closeModal() {
    this.close.emit();
  }
}

// Upload Adapter for base64 images
export class UploadAdapter {
  private loader: any;

  constructor(loader: any) {
    this.loader = loader;
  }

  public async upload(): Promise<any> {
    const file = await this.loader.file;
    const dataUrl = await this.readThis(file);
    return { default: dataUrl };
  }

  private readThis(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
      reader.readAsDataURL(file);
    });
  }
}
